import { Component, inject, ChangeDetectionStrategy } from "@angular/core";

import { ServiceContractsComponent } from "./components/service-contracts/service-contracts.component";
import { PredictiveServiceComponent } from "./components/predictive-service/predictive-service.component";
import { TranslateModule } from "@ngx-translate/core";
import { HasPermissionDirective } from "../../shared/directives/has-permission/has-permission.directive";
import { PermissionService } from "../../services/api/permission/permission.service";
import { TabsModule } from "@openng/optimus-ui/tabs";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { filter, map, startWith } from "rxjs";

@Component({
  standalone: true,
  selector: "app-service-orders",
  imports: [TabsModule, ServiceContractsComponent, PredictiveServiceComponent, TranslateModule, HasPermissionDirective],
  templateUrl: "./service-orders.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./service-orders.component.scss",
})
export class ServiceOrdersComponent {
  public permissions = inject(PermissionService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);
  public tabValue = "0";

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        startWith(null),
        map(() => this.activatedRoute.snapshot.queryParams["tab"]),
        takeUntilDestroyed()
      )
      .subscribe({
        next: (tab) => {
          if (tab) {
            this.tabValue = tab.toString();
          }
        },
      });
  }
}
